
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'trash': {
    width: 17.7,
    height: 24.5,
    viewBox: '0 0 17.7 24.5',
    data: '<path pid="0" d="M16.9 1.7h-4.3l-.5-.8c-.4-.6-1-.9-1.7-.9H7.3C6.6 0 6 .4 5.6.9l-.5.8H.9c-.5 0-.9.4-.9.9v.9h17.7v-.9c0-.5-.4-.9-.8-.9zM2.3 21c.2 2 1.9 3.5 3.9 3.5h5.3c2 0 3.6-1.5 3.9-3.5l1.5-16.6H.9L2.3 21zM12.4 6.1h.9L12.4 21h-.9l.9-14.9zm-4 0h.9V21h-.9V6.1zm-3.1 0L6.2 21h-.9L4.4 6.1h.9z"/>'
  }
})
